module.exports = __webpack_public_path__ + "img/item17.66e75fb2.png";